import React from 'react';
import GIInterventionPointDaySchedule from './GIInterventionPointDaySchedule';

const GIMobileInterventionPointDayView = ({ fetchWithAuth }) => (
  <GIInterventionPointDaySchedule fetchWithAuth={fetchWithAuth} layout="mobile" />
);

export default GIMobileInterventionPointDayView;
